import React from 'react';
import { Spin, Table, Tooltip, Button, Icon, Input, Col, Row, Modal, Select } from 'antd';
import { sanitizerTexto } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import EquivalenciaArticuloRequest from '../../services/EquivalenciaArticulo';
import FormEquivalenciaArticuloRequest from './FormEquivalenciaArticulos';
import CatalogosRequest from '../../services/Catalogos';
import ArticulosRequest from '../../services/Articulos';
import ResponsiveCard from '../Common/ResponsiveCard';
import BaseComponent from '../Common/BaseComponent';
const { confirm } = Modal;
const { Option } = Select
const { Search } = Input;

/**
 * Clase para ver el proceso de mostrar artículos
 */
export default class EquivalenciaArticulo extends BaseComponent {
    state = {
        arrEquivalencias: [],
        arrEquivalenciasCopy: [],
        filterText: "",
        cargando: false,
        modo: null,
        tipo_modal: null,
        modalEquivalencias: false,
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        arrDrives: [],
        arrSegmentos: [],
        regionSelected: null,
        sucursalSelected: null,
        segmentoSelected: null,
        plazaSelected: null,
        drivesSelected: [],
        disableDeleteFilters: true,
        disableApplyFilters: true,
        disableNuevaEquivalencia: true,
        arrArticulosBusqueda: [],
        valueBuscarArt: null,
        articuloSelectedEq: null,
    }

    /**
     * Comportamiento del componente al mostrar los artículos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        CatalogosRequest.ListarRegiones()
            .then(response => {
                state.arrRegiones = response.data
                return CatalogosRequest.ListarSegmentosConfigurados();
            }).then(response => {
                state.arrSegmentos = response.data;
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar las regiones.",
                    "Error al listar regiones",
                    false
                )
            })
    }

    /**
     * Función que se ejecuta para cargar las equivalencias
     */
    cargarEquivalencias = () => {
        let state = { ...this.state }
        let obj_enviar = {}
        obj_enviar.sitios = state.drivesSelected;
        obj_enviar.articulo_id = state.articuloSelectedEq;
        this.setState({ cargando: true, categoriaSelected: null }, () => {
            EquivalenciaArticuloRequest.ListarEquivalencias(obj_enviar)
                .then(response => {
                    state.arrEquivalencias = response.data
                    state.arrEquivalenciasCopy = response.data
                    state.cargando = false
                    this.setState(state)

                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        "Ha ocurrido un error al listar las equivalencias",
                        "Error al listar equivalencias",
                        false
                    )
                })
        })
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrEquivalenciasCopy = state.arrEquivalencias
        if (value) {
            arrEquivalenciasCopy = arrEquivalenciasCopy.filter(obj => {
                return sanitizerTexto(value, obj.articulo.codigo)
                    || sanitizerTexto(value, obj.articulo.descripcion)
            })
        }
        state.arrEquivalenciasCopy = arrEquivalenciasCopy
        this.setState(state);
    }

    /**
     * Función para mostar el modal de categorización
     * @param: nada
     * @return: nada
     */
    showModal = () => {
        this.setState({ modalEquivalencias: true })
    }

    /**
     * Función para esconder modal de categorización
     * @param: value. true o false
     * @return: nada
     */
    esconderModal = (value) => {
        let state = { ...this.state }
        state.modalEquivalencias = false;
        state.categoriaSelected = null;
        this.setState(state)
        if (value) this.cargarEquivalencias()
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }
        state.sucursalSelected = null;
        state.disableApplyFilters = true;
        state.plazaSelected = null;
        state.drivesSelected = [];
        state.disableCreateMinimo = true;
        state.arrArticulosMinimos = [];
        state.arrArticulosMinimosCopy = [];
        state.segmentoSelected = null;
        if (value === undefined) {
            state.regionSelected = null;
            state.disableDeleteFilters = true
        } else {
            state.regionSelected = value
            CatalogosRequest.ListarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                state.disableDeleteFilters = false
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error al cargar sucursales",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null;
        state.drivesSelected = [];
        state.disableApplyFilters = true;
        state.disableCreateMinimo = true;
        state.arrArticulosMinimos = [];
        state.arrArticulosMinimosCopy = [];
        state.segmentoSelected = null;
        if (value === undefined) {
            state.sucursalSelected = null;
        } else {
            state.sucursalSelected = value
            CatalogosRequest.ListarPlazasSucursal(value).then(response => {
                state.arrPlazas = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las plazas de la sucursal.",
                    "Error al cargar plazas",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    handleChangePlaza = (value) => {
        let state = { ...this.state }
        state.drivesSelected = [];
        state.disableApplyFilters = true;
        state.disableCreateMinimo = true;
        state.arrArticulosMinimos = [];
        state.arrArticulosMinimosCopy = [];
        state.segmentoSelected = null;
        if (value === undefined) {
            state.plazaSelected = null;
        } else {
            state.plazaSelected = value
            const role = localStorage.getItem("role")
            if ( role !== 'Administrador' && role !== 'SuperAdmin') {
                CatalogosRequest.ListarSitiosPlazaUsuario(value, localStorage.getItem("id_user")).then(response => {
                    state.arrDrives = response.data
                    this.setState(state)
                }).catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar los drives de la plaza.",
                        "Error al cargar drives",
                        false
                    )
                })
            }
        }

        this.setState(state)
    }

    /**
     * Función que se cambia el segmento
     * @param: value. valor del id del segmento
     * @return: nada.
     */
    handleChangeSegmento = (value) => {
        let state = { ...this.state }
        state.drivesSelected = [];
        state.filterText = "";
        state.disableApplyFilters = true
        state.arrEquivalencias = [];
        state.arrEquivalenciasCopy = [];
        state.disableNuevaEquivalencia = true;
        state.arrArticulosBusqueda = [];
        state.articuloSelectedEq = null;
        state.valueBuscarArt = null;
        if (value === undefined) {
            state.segmentoSelected = null;
        } else {
            state.segmentoSelected = value
            CatalogosRequest.ListarSitios(state.plazaSelected, value).then(response => {
                state.arrDrives = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar los drives de la plaza.",
                    "Error al cargar drives",
                    false
                )
            })
        }

        this.setState(state)
    }


    /**
     * Función cuando se cambia el combo de drive
     * @param: value. valor del id del drive
     * @return: nada.
     */
    handleChangeDrive = (value) => {
        let state = { ...this.state }
        state.arrEquivalencias = [];
        state.arrEquivalenciasCopy = [];
        state.disableNuevaEquivalencia = true;
        state.arrArticulosBusqueda = [];
        state.articuloSelectedEq = null;
        state.valueBuscarArt = null;
        if (!value.length) {
            state.drivesSelected = [];
            state.disableApplyFilters = true
        } else {
            state.drivesSelected = value
            if (value.length > 1) {
                state.disableApplyFilters = true
            } else {
                state.disableApplyFilters = false
                state.disableNuevaEquivalencia = false;
            }

        }

        this.setState(state)
    }

    /**
    * Función para limpiar todos los filtros que han
    * sido manipulados por el usuario.
    * @param: nada
    * @return: nada
    */
    cleanFilters = () => {
        let state = { ...this.state }
        state.filterText = '';
        state.disableApplyFilters = true;
        state.disableDeleteFilters = true;
        state.regionSelected = null;
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.drivesSelected = [];
        state.arrEquivalencias = [];
        state.arrEquivalenciasCopy = [];
        state.arrArticulosBusqueda = [];
        state.articuloSelectedEq = null;
        state.valueBuscarArt = null;
        state.disableNuevaEquivalencia = true;
        state.segmentoSelected = null
        this.setState(state);
        openNotification("Los filtros se han limpiado correctamente.", "Filtros limpiados correctamente", true);
    }

    /**
     * Comportamiento al confirmar eliminar clendario
     * @param: nada.
     * @return: nada.
     */
    showConfirmDelete = () => {
        confirm({
            title: 'Confirmar',
            content: <div><b>¿Está seguro de eliminar la equivalencia?</b> Se borrará la equivalencia definitivamente.</div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-eliminar-equivalencia-form',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-eliminar-equivalencia-form',
            },
            onOk: () => {
                this.setState({ cargando: true })
                EquivalenciaArticuloRequest.EliminarEquivalencia(this.state.categoriaSelected.id)
                    .then(response => {
                        this.setState({ categoriaSelected: null })
                        openNotification(
                            "Se ha eliminado correctamente la equivalencia.",
                            "Equivalencia eliminada correctamente",
                            true
                        )
                        this.cargarEquivalencias();
                    })
                    .catch(err => {
                        this.setState({ cargando: false })
                        openNotification(
                            err.response.data.cuerpo,
                            "Error al eliminar equivalencia",
                            false
                        )
                    })
            },
            onCancel: () => {
                this.setState({ categoriaSelected: null, modo: null })

            }
        });
    }

    /**
     * Función que se ejecuta cuando se da clic 
     * en buscar en input search
     * @param: value. valor del input search
     * @return: nada.
     */
    buscarArticulo = (value) => {
        let state = { ...this.state }
        let filtros = {}
        if (value.trim()) {
            filtros.filtro = value
            this.setState({ cargando: true }, () => {
                ArticulosRequest.ListarArticulos(filtros)
                    .then(response => {
                        state.arrArticulosBusqueda = response.data.results
                        state.cargando = false;
                        this.setState(state)
                        if (!response.data.results.length) openNotification(
                            "No se ha encontrado un artículo con el código / descripción ingresado.",
                            "Verificar búsqueda",
                            false
                        )
                    })
                    .catch(err => {
                        this.setState({ cargando: false })
                        openNotification(err?.response?.data?.cuerpo, err?.response?.data?.cuerpo, false)
                    })
            })
        }
    }

    handleChangeArticulo = (value) => {
        let state = { ...this.state };
        state.articuloSelectedEq = value;
        state.disableApplyFilters = value ? false : true
        state.disableNuevaEquivalencia = value ? false : true
        this.setState(state)
    }

    render() {
        const columnasCategorias = [
            {
                title: "Sitio",
                dataIndex: "sitio_nombre",
                key: "sitio_nombre"
            },
            {
                title: "Código",
                dataIndex: "articulo.codigo",
                key: "articulo.codigo"
            },
            {
                title: "Descripción",
                dataIndex: "articulo.descripcion",
                key: "articulo.descripcion"
            },
            {
                title: "Unidad de compra",
                dataIndex: "articulo.unidad_compra",
                key: "articulo.unidad_compra"
            },
            {
                title: "Múltiplos",
                dataIndex: "multiplo",
                key: "multiplo"
            },
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                render: (_, record) => (
                    <div>
                        <div>
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Editar equivalencia"}>
                                    <Button
                                        id="boton-editar-equivalencia-row"
                                        icon="edit"
                                        className="btnEditar"
                                        onClick={() => {
                                            this.setState({
                                                categoriaSelected: record,
                                                modo: "editar",
                                                tipo_modal: 'uno'
                                            }, this.showModal())
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Eliminar equivalencia"}>
                                    <Button
                                        id="boton-eliminar-equivalencia-row-modulo-cat"
                                        icon="delete"
                                        className="btnEditar"
                                        onClick={() => {
                                            this.setState({
                                                categoriaSelected: record,
                                                modo: 'eliminar'
                                            }, this.showConfirmDelete)
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                        </div>
                    </div>
                )
            }
        ]

        const searchButtons = <>
            <Col span={this.state.isPos ? 3 : 2}>
                <Tooltip placement="top" title={this.state.plazaSelected !== null ? "Realizar búsqueda" : ""}>
                    <Button
                        id="boton-filtrar-equivalencias-nueva-forma"
                        className={this.state.disableApplyFilters ? "disableBtn" : ""}
                        type={this.state.disableApplyFilters ? "default" : "primary"}
                        icon="search"
                        style={{ width: '100%', marginLeft: '4.5%', marginBottom: "30px", marginTop: '1.85em' }}
                        onClick={this.cargarEquivalencias}
                    >
                    </Button>
                </Tooltip>
            </Col>
            <Col span={this.state.isPos ? 3 : 2}>
                <Tooltip placement="top" title="Borrar filtros">
                    <Button
                        id="boton-borrar-filtros-prductos-minimo"
                        type="default"
                        icon="delete"
                        className={this.state.disableDeleteFilters ? 'disableBtn' : ''}
                        style={{ width: '100%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.85em' }}
                        onClick={this.cleanFilters}
                    >
                    </Button>
                </Tooltip>
            </Col>
        </>

        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo equivalencia de artículos"
                extra={
                    <div>
                        <Button
                            className="btnVerCrearGuardar"
                            disabled={this.state.disableNuevaEquivalencia}
                            type="primary"
                            id="boton-nueva-equivalencia-articulos-modulo"
                            onClick={() => {
                                this.setState({ modo: 'nuevo', tipo_modal: 'dos' }, () => {
                                    this.showModal();
                                })

                            }}
                        >
                            Nueva equivalencia
                        </Button>
                    </div>
                }>

                <div className="panel-block">
                    <Row gutter={12}>
                        <Col span={8}>
                            <div className="center">Región:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una región">
                                <Select
                                    id="select-region-calendario-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    onChange={this.handleChangeRegion}
                                    value={this.state.regionSelected}
                                    allowClear
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrRegiones.length > 0 &&
                                        this.state.arrRegiones.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre_corto}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col span={8}>
                            <div className="center">Sucursal:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una sucursal">
                                <Select
                                    id="select-sucursal-calendario-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.regionSelected === null ? true : false}
                                    onChange={this.handleChangeSucursal}
                                    value={this.state.sucursalSelected}
                                    allowClear
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrSucursales.length > 0 &&
                                        this.state.arrSucursales.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col span={8}>
                            <div className="center">Plaza:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una plaza">
                                <Select
                                    id="select-plaza-calendario-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.sucursalSelected === null ? true : false}
                                    onChange={this.handleChangePlaza}
                                    value={this.state.plazaSelected}
                                    allowClear
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrPlazas.length > 0 &&
                                        this.state.arrPlazas.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                    </Row> <br />
                    <Row gutter={12}>
                        {
                            ["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))
                            ? <>
                                <Col span={8}>
                                    <div className="center">Segmento:</div>
                                    <Tooltip
                                        placement="top"
                                        title="Seleccione un segmento">
                                        <Select
                                            id="select-segmento-calendario-modulo"
                                            showSearch
                                            style={{ width: "100%" }}
                                            defaultActiveFirstOption={false}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            disabled={this.state.plazaSelected === null ? true : false}
                                            onChange={this.handleChangeSegmento}
                                            value={this.state.segmentoSelected}
                                        >
                                            <Option value={null} disabled={true}>Seleccionar...</Option>
                                            {
                                                this.state.arrSegmentos.length > 0 &&
                                                this.state.arrSegmentos.map(obj => {
                                                    return (
                                                        <Option
                                                            key={obj.id}
                                                            value={obj.id}>
                                                            {obj.nombre}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Tooltip>
                                </Col>
                            </>
                            : <></>
                        }

                        <Col span={8}>
                            <div className="center">Punto de venta:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione punto de venta">
                                <Select
                                    id="select-drive-calendario-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    mode="multiple"
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role")) ? this.state.segmentoSelected === null : this.state.plazaSelected === null}
                                    onChange={this.handleChangeDrive}
                                    value={this.state.drivesSelected}
                                    allowClear
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrDrives.length > 0 &&
                                        this.state.arrDrives.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        { this.state.drivesSelected?.length < 2 ? searchButtons : ''}
                        <Col className={this.state.drivesSelected?.length > 1 ? '' : 'display-none'} span={8}>
                            <div className="center">Buscar artículo:</div>
                            <Tooltip
                                placement="top"
                                title="Buscar artículo">
                                <Search
                                    value={this.state.valueBuscarArt}
                                    id="input-search-articulo-equivalencia-nueva-forma"
                                    placeholder="Ingrese Código / Descripción"
                                    enterButton="Buscar"
                                    onChange={(e) => this.setState({ valueBuscarArt: e.currentTarget.value })}
                                    onSearch={value => { this.buscarArticulo(value) }}
                                />
                            </Tooltip>
                        </Col>
                    </Row>
                    <Row>
                        <Col className={this.state.drivesSelected?.length > 1 ? '' : 'display-none'} span={8}>
                            <div className="center">Seleccionar artículo:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione artículo">
                                <Select
                                    allowClear={true}
                                    id="select-articulo-form-articulo-equivalencias"
                                    className={(!this.state.arrArticulosBusqueda?.length) ? 'disableInputText' : ''}
                                    disabled={(!this.state.arrArticulosBusqueda?.length) ? true : false}
                                    defaultActiveFirstOption={false}
                                    style={{ width: "100%" }}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    onChange={this.handleChangeArticulo}
                                    value={this.state.articuloSelectedEq}
                                >
                                    <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrArticulosBusqueda?.length > 0 &&
                                        this.state.arrArticulosBusqueda?.map(obj => {
                                            return (
                                                <Option
                                                    key={obj?.id}
                                                    value={obj?.id}>
                                                    {obj?.codigo_descripcion}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        { this.state.drivesSelected?.length > 1 ? searchButtons : ''}

                    </Row>
                    <Row>
                        <Col className={this.state.arrEquivalencias.length ? '' : 'display-none'} span={12} style={{ marginBottom: "15px"}}>
                            <div className="center">Búsqueda:</div>
                            <Tooltip
                                placement="top"
                                title="Buscar por Código / Nombre ">
                                <Input
                                    autoFocus={true}
                                    maxLength={50}
                                    id="input-buscar-equivalencia-modulo"
                                    placeholder="Buscar por Código / Nombre"
                                    onChange={(e) => this.filterText(e.currentTarget.value)}
                                    value={this.state.filterText}
                                />
                            </Tooltip>
                        </Col>
                    </Row>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={categoria => categoria.id}
                            columns={columnasCategorias}
                            dataSource={this.state.arrEquivalenciasCopy}
                            pagination={{ showTitle: false }}
                        />
                    </Spin>
                </div>
                <FormEquivalenciaArticuloRequest
                    esconderModal={this.esconderModal}
                    visible={this.state.modalEquivalencias}
                    type={this.state.tipo_modal}
                    modo={this.state.modo}
                    drives_selected={this.state.drivesSelected}
                    articulo_selected={this.state.articuloSelectedEq}
                    detalleCategoria={this.state.categoriaSelected}
                >
                </FormEquivalenciaArticuloRequest>
            </ResponsiveCard>
        )
    }
}